export const SEND_FORGOT_PASSWORD_REQUEST = 'SEND_FORGOT_PASSWORD_REQUEST'
export const SEND_FORGOT_PASSWORD_SUCCESS = 'SEND_FORGOT_PASSWORD_SUCCESS'
export const SEND_FORGOT_PASSWORD_FAIL = 'SEND_FORGOT_PASSWORD_FAIL'

export const VERIFICATION_OTP_FORGOT_PASSWORD_REQUEST = 'VERIFICATION_OTP_FORGOT_PASSWORD_REQUEST'
export const VERIFICATION_OTP_FORGOT_PASSWORD_SUCCESS = 'VERIFICATION_OTP_FORGOT_PASSWORD_SUCCESS'
export const VERIFICATION_OTP_FORGOT_PASSWORD_FAIL = 'VERIFICATION_OTP_FORGOT_PASSWORD_FAIL'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'

export const RESET_FORGOT_PASSWORD = 'RESET_FORGOT_PASSWORD'